// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"be118470","231":"45582c77","236":"8feca72c","337":"3a2bb087","375":"d5d56332","451":"20891ab5","781":"ff80b623"}[chunkId] + ".chunk.css";
};